<div>
  <div class="slider-container">
    <button
      class="arrow left"
      (click)="previous()"
      [disabled]="activeIndex === 0"
    >
      <mat-icon>arrow_back_ios</mat-icon>
    </button>

    <div
      class="slider"
      [style.transform]="'translateX(-' + activeIndex * 100 + '%)'"
    >
      <div class="slide">
        <app-drone-model-vector [device]="device"></app-drone-model-vector>
      </div>
      <div class="slide">
        <app-drone-model-scorpion [device]="device"></app-drone-model-scorpion>
      </div>
    </div>

    <button
      class="arrow right"
      (click)="next()"
      [disabled]="activeIndex === items.length - 1"
    >
      <mat-icon>arrow_forward_ios</mat-icon>
    </button>
  </div>
  <div class="dots">
    <span
      *ngFor="let item of items; let i = index"
      class="dot"
      [class.active]="i === activeIndex"
      (click)="showComponent(i)"
    >
    </span>
  </div>
</div>
